// nearMissForm/components/signatureSection.js

import React from "react";
import { SignatureModal } from "../../common/SignatureModal";
import { DelDatePicker } from "../../common/DelDatePicker";
import styles from "./signatureSection.module.css";

const SignatureRow = ({
  employeeName,
  signatureDate,
  signatureInfoImage,
  disabled,
  actions,
  emitPatch,
}) => {
  const onSign = () => actions.toggleSignatureModal(true);

  return (
    <div className={styles.signatureCard}>
      <div className={styles.inputGrid}>
        <div className={styles.inputField}>
          <label>Name</label>
          <input
            type="text"
            value={employeeName || ""}
            className={styles.textInput}
            readOnly={true}
          />
        </div>
        <div className={styles.inputField}>
          <label>Date</label>
          <DelDatePicker
            id="signatureDate"
            selected={signatureDate}
            onChange={(date) => actions.updateSignatureDate(date, emitPatch)}
            disabled={disabled}
            className={styles.dateInput}
            placeholder="Signature Date"
            isClearable={true}
            showPopperArrow={false}
            onFocus={(e) => (e.target.readOnly = true)}
          />
        </div>
      </div>

      <div
        className={styles.signatureDisplay}
        onClick={!disabled ? onSign : undefined}
      >
        {signatureInfoImage ? (
          <img
            src={signatureInfoImage}
            alt="Signature"
            className={styles.signatureImage}
          />
        ) : (
          <div className={styles.emptySignature}>
            <span>Click to sign</span>
          </div>
        )}
      </div>

      <div className={styles.signatureCardActions}>
        <button
          className={styles.signButton}
          onClick={onSign}
          disabled={disabled}
        >
          Sign
        </button>
      </div>
    </div>
  );
};

export const NearMissSignatureSection = ({
  employeeName,
  signatureDate,
  signatureInfoImage,
  nearMissMode,
  actions,
  ui,
  emitPatch,
  user,
}) => {
  const disabled = nearMissMode === "view";

  const handleClose = () => actions.closeSignatureModal();

  // Save signature via modal - sends signature data via WebSocket
  const handleSave = (signature, signeeRowId) => {
    actions.saveSignature(signature, emitPatch, user);
  };

  // Clear signature
  const handleClear = () => {
    actions.clearSignature(emitPatch);
  };

  return (
    <div className={styles.signatureTableContainer}>
      <SignatureModal
        isOpen={ui.signatureModalOpen}
        onClose={handleClose}
        signee={ui.currentSignatureRowId}
        existingSignature={ui.currentSignatureImage}
        onSave={handleSave}
        onClear={handleClear}
      />

      <div className={styles.signatureCardList}>
        <SignatureRow
          employeeName={employeeName}
          signatureDate={signatureDate}
          signatureInfoImage={signatureInfoImage}
          disabled={disabled}
          actions={actions}
          emitPatch={emitPatch}
        />
      </div>
    </div>
  );
};
